import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["autoHeight", "children", "maxHeight", "maxWidth", "ScrollContainer", "scrollDirection"];
import { Component } from 'react';
import styled from 'foundations-theming/utils';
import { ScrollOverhang } from '../ScrollOverhang/ScrollOverhang';
import { toPx } from '../../../utils/toPx';
import { jsx as _jsx } from "react/jsx-runtime";
const isHorizontal = direction => direction === 'horizontal' || direction === 'both';
const isVertical = direction => direction === 'vertical' || direction === 'both';
const DefaultScrollContainer = styled.div.withConfig({
  displayName: "ScrollContainer__DefaultScrollContainer",
  componentId: "sc-1vs5tls-0"
})(["height:", ";width:100%;max-height:", ";max-width:", ";overflow-x:", ";overflow-y:", ";position:relative;"], props => props.$autoHeight ? 'auto' : '100%', props => toPx(props.$maxHeight), props => toPx(props.$maxWidth), props => isHorizontal(props.$scrollDirection) ? 'auto' : 'hidden', props => isVertical(props.$scrollDirection) ? 'auto' : 'hidden');
export class ScrollContainer extends Component {
  constructor(...args) {
    super(...args);
    this.refCallback = ref => {
      const {
        connectDragSource,
        connectDropTarget,
        scrollElementRef
      } = this.props;
      if (!(scrollElementRef || connectDragSource || connectDropTarget)) return;
      const el = ref;
      if (scrollElementRef) {
        if (typeof scrollElementRef === 'function') {
          scrollElementRef(el);
        } else {
          scrollElementRef.current = el;
        }
      }
      if (connectDragSource) connectDragSource(el);
      if (connectDropTarget) connectDropTarget(el);
    };
  }
  render() {
    const _this$props = this.props,
      {
        autoHeight,
        children,
        maxHeight,
        maxWidth,
        ScrollContainer: _ScrollContainer = DefaultScrollContainer,
        scrollDirection = 'both'
      } = _this$props,
      rest = _objectWithoutPropertiesLoose(_this$props, _excluded);
    return /*#__PURE__*/_jsx(ScrollOverhang, Object.assign({}, rest, {
      children: /*#__PURE__*/_jsx(_ScrollContainer, {
        $autoHeight: autoHeight,
        $maxHeight: maxHeight,
        $maxWidth: maxWidth,
        ref: this.refCallback,
        $scrollDirection: scrollDirection,
        children: children
      })
    }));
  }
}